import DatePicker from 'antd/lib/date-picker'
import moment from 'moment'
import React, { Component } from 'react'
import LocaleProvider from 'antd/lib/locale-provider'
import zhCN from 'antd/lib/locale-provider/zh_CN';

const mapDefaultToValue = (defaultValue) => {
  return defaultValue ? moment(defaultValue) : null
}
const mapValuetoValue = value => +value

export default class TimeRangePicker extends Component {
  state = {
    value: mapDefaultToValue(this.props.defaultValue, this.props)
  }
  componentWillReceiveProps(nextProps) {
    const { defaultValue, reset } = this.props
    const { defaultValue: d } = nextProps
    if (d !== defaultValue || reset) {
      this.setState({
        value: mapDefaultToValue(d)
      })
    }
  }
  handleChange = (value) => {
    const { onChange } = this.props
    this.setState({
      value
    })
    onChange && onChange(mapValuetoValue(value))
  }
  render() {
    const { value } = this.state
    const { defaultValue, onChange, ...others } = this.props

    return (
      <LocaleProvider locale={zhCN}>
        <DatePicker
          value={value}
          format="YYYY-MM-DD"
          onChange={this.handleChange}
          {...others}
        />
      </LocaleProvider>
    )
  }
}
